import Swal from "sweetalert2";

export const errorAlert = (text) => {
  return Swal.fire({
    icon: "error",
    title: "Request Failed",
    text,
  });
};


